// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const PersonMale: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 12a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5Zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM19 22H4.999a1 1 0 0 1-.989-1.151l-.001.006.753-5.164A1.91 1.91 0 0 1 6.613 14H17.383a1.909 1.909 0 0 1 1.852 1.682l.001.009.753 5.164A1 1 0 0 1 19 22h-.001H19ZM6.157 20h11.687l-.584-4H6.744l-.587 4Z" />
  </SvgIcon>
);

PersonMale.activeColor = 'inherit';
PersonMale.muiName = 'PersonMale';
